import { render, staticRenderFns } from "./Dashparent.vue?vue&type=template&id=f73cc700&"
import script from "./Dashparent.vue?vue&type=script&lang=js&"
export * from "./Dashparent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports